// import { useTranslations } from "next-intl";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Styles from "./Services.module.css";
import { useSelector } from "react-redux";
import webImg from "../../assets/webImg.png"
import appimg from "../../assets/mobileapp1.png"
import uxImg from "../../assets/mobileapp.png"
import images from "../../assets/wordpress.png"
import { motion } from "framer-motion";

export default function Index({ state }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  return (
    <div className={Styles.serviceContainer}>
      <div className={Styles.title}>
                            <motion.div
          initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="rightBox"
      >
        <h3>{currentLocal.general.ourServices}</h3>
        </motion.div>
      </div>
      <div className={Styles.cardContainer} >
        <Container fluid>
                                      <motion.div
          initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="rightBox"
      >
          <Row>
            <Col md={3} style={{marginBottom:"25px"}}>
           
              <div className={Styles.card}>
                <div className={Styles.cardHeader}> 
                <img src={webImg} alt="webImg" />

                </div>
                <div className={state ? Styles.cardBodyDes : Styles.cardBody}>
                  <h3>{currentLocal.general.websiteDevelopment}</h3>
                  {state && <p>{currentLocal.general.webDesc}</p>}
                </div>
              </div>
             
            </Col>
            <Col md={3} style={{marginBottom:"25px"}}>
           
              <div className={Styles.card}>
                <div className={Styles.cardHeader}>
                <img src={appimg} alt="appImg" />

                </div>
                <div className={state ? Styles.cardBodyDes : Styles.cardBody}>
                  <h3>{currentLocal.general.appDeveloper}</h3>
                  {state && <p>{currentLocal.general.appDesc}</p>}
                </div>
              </div>
             
            </Col>
            <Col md={3} style={{marginBottom:"25px"}}>
           
              <div className={Styles.card}>
                <div className={Styles.cardHeader}>
                  {" "}
                  <img src={uxImg} alt="uxImg" />
                </div>
                <div className={state ? Styles.cardBodyDes : Styles.cardBody}>
                  <h3>{currentLocal.general.userExp}</h3>
                  {state && <p>{currentLocal.general.userDesc}</p>}
                </div>
              </div>
             
            </Col>
            <Col md={3} style={{marginBottom:"25px"}}>
           
              <div className={Styles.card}>
                <div className={Styles.cardHeader}>
                  {" "}
                  <img src={images} alt="uxImg" />
                </div>
                <div className={state ? Styles.cardBodyDes : Styles.cardBody}>
                  <h3>{currentLocal.general.wordpress}</h3>
                  {state && <p>{currentLocal.general.wordpressText}</p>}
                </div>
              </div>
             
            </Col>
          </Row>
          </motion.div>
        </Container>
      </div>
    </div>
  );
}
